module.exports = __webpack_public_path__ + "img/36c)(Hotel Dominican)Montage von über 200 Gästezimmer.jpg";